import React from 'react';
import { AlertCircle, CheckCircle, X } from 'lucide-react';

export const ErrorAlert = ({ message, onClose }) => {
  if (!message) return null;
  return (
    <div className="bg-[#E3000F]/10 border border-[#E3000F]/30 p-4 mb-6 flex items-center gap-3" data-testid="error-alert">
      <AlertCircle className="w-5 h-5 text-[#E3000F] flex-shrink-0" />
      <p className="text-[#E3000F]">{message}</p>
      <button onClick={onClose} className="ml-auto text-[#E3000F] hover:text-white">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export const SuccessAlert = ({ message, onClose }) => {
  if (!message) return null;
  return (
    <div className="bg-[#009246]/10 border border-[#009246]/30 p-4 mb-6 flex items-center gap-3" data-testid="success-alert">
      <CheckCircle className="w-5 h-5 text-[#009246] flex-shrink-0" />
      <p className="text-[#009246]">{message}</p>
      <button onClick={onClose} className="ml-auto text-[#009246] hover:text-white">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
